export default __webpack_public_path__ + "static/media/Eye_1_M_C6.0322adf8.svg";